export enum GridKeys {
  G = 'g',
  PLUS = '+',
  MINUS = '-',
}
